module.exports = __webpack_public_path__ + "static/media/import.87e664a9.svg";